import type { ApiPiece } from "@/hooks/use-projects";
import { PlatformIcon } from "@/components/ui/platform-icon";
import { Badge } from "@/components/ui/badge";
import { AiScoreBadge } from "@/components/ui/ai-score-badge";
import { POST_TYPE_META, type PostType } from "@/hooks/use-post-generation";
import { MediaPreview, mediaItemFromPiece } from "@/components/media";

interface KanbanCardProps {
  piece: ApiPiece;
  onClick: () => void;
}

function pieceTypeLabel(piece: ApiPiece): string {
  const pt = piece.postType as PostType | null | undefined;
  if (pt && POST_TYPE_META[pt]) return POST_TYPE_META[pt].label;
  return piece.format.toLowerCase();
}

export function KanbanCard({ piece, onClick }: KanbanCardProps) {
  const mi = mediaItemFromPiece({
    id: piece.id,
    mediaUrls: piece.mediaUrls,
    thumbnailUrl: piece.thumbnailUrl,
    format: piece.format,
    title: piece.shortCode,
  });
  return (
    <div
      className="cursor-pointer rounded-lg border bg-card p-3 shadow-sm transition-colors hover:border-foreground/20"
      onClick={onClick}
    >
      {mi && (
        <MediaPreview item={mi} hoverPlay={false} className="aspect-video w-full mb-1.5" />
      )}
      <div className="flex items-center gap-2">
        <PlatformIcon platform={piece.platform} size={14} />
        <span className="font-mono text-xs text-muted-foreground">{piece.shortCode}</span>
        <AiScoreBadge score={piece.aiReviewScore} className="ml-auto text-[10px]" />
        <Badge
          variant="outline"
          className={piece.aiReviewScore != null ? "text-[10px]" : "ml-auto text-[10px]"}
        >
          {pieceTypeLabel(piece)}
        </Badge>
      </div>
      <p className="mt-2 text-sm line-clamp-1">{piece.copy || piece.caption}</p>
    </div>
  );
}
